import React from 'react';
import { Box, Container } from '@mui/material';
import Navigation from '../components/Navigation';

export const withNavigation = <P extends object>(
    WrappedComponent: React.ComponentType<P>
) => {
    return (props: P) => {
        return (
            <Box sx={{ display: 'flex' }}>
                <Navigation />
                <Box 
                    sx={{ 
                        flexGrow: 1, 
                        ml: '6em', 
                        mr: '2em',
                        py: 2,
                        width: 'calc(100% - 64px)',
                    }}
                >
                    <WrappedComponent {...props} />
                </Box>
            </Box>
        );
    };
}; 